import { Component, OnInit } from '@angular/core';
import { TextService } from 'src/app/services/text-service.service';

@Component({
  selector: 'app-vision',
  templateUrl: './vision.component.html',
  styleUrls: ['./vision.component.css']
})
export class VisionComponent implements OnInit {

  constructor(public textDefinitions: TextService) { }

  ngOnInit() {
  }

}
